import { render, staticRenderFns } from "./option-editor.pug?vue&type=template&id=5455163f&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./option-editor.scss?vue&type=style&index=0&id=5455163f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455163f",
  null
  
)

export default component.exports